import ProjectCard from "../items/ProjectCard";
import SectionLabel from "../items/SectionLabel";

import { forwardRef } from "react";
function PortfolioComponent(
  props: JSX.IntrinsicAttributes,
  ref: React.ForwardedRef<HTMLDivElement>
): JSX.Element {
  return (
    <main ref={ref} {...props} className=" portfolio-section">
      <SectionLabel title="Portfolio" />

      <div className="portfolio-container">
        <ProjectCard
          title="Rich Text Editor"
          description="A simple text editor made in html and javascript"
          repositoryLink="https://github.com/Puszkarek/rich-text-editor"
          color="#ACD5E6"
        />
        <ProjectCard
          title="Whatsapp Bot"
          description="Bot make with node.js"
          repositoryLink="https://github.com/Puszkarek/whatsapp-bot"
          color="#ACE6BA"
        />

        <ProjectCard
          title="Let Me Ask"
          description="Questions &amp; Answers application with React and Firebase"
          repositoryLink="https://github.com/Puszkarek/let-me-ask"
          color="#E6ACAC"
        />
        <ProjectCard
          title="Voice Maker"
          description="Voice recorder made with typescript and html"
          repositoryLink="https://github.com/Puszkarek/voice-maker"
          liveDemoLink="https://voice-maker.vercel.app/"
          color="#ACD5E6"
        />
        <ProjectCard
          title="Newsletter"
          description="Page for newsletter subscribe built with Next.js"
          liveDemoLink="https://newsletter-mu.vercel.app/"
          color="#E6ACE2"
        />
        <ProjectCard
          title="User Api"
          description="A little demo with express in typescript for create user"
          repositoryLink="https://github.com/Puszkarek/create-user-api-demo"
          color="#ACDAE6"
        />
      </div>
      <p className="portfolio-footer">And many more to come</p>
    </main>
  );
}
export const Portfolio = forwardRef(PortfolioComponent);
